import { connect } from 'react-redux'
import { pageToggleOverlay } from 'redux/actions'
import Pagination from 'components/search/Pagination'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  searchType: state.search.searchType,
  paginationMode: state.search.paginationMode
})

const mapDispatchToProps = dispatch => ({
  pageToggleOverlay: (component) => dispatch(pageToggleOverlay(component))
})

export default connect(mapStateToProps, mapDispatchToProps)(Pagination)
